import { Accordion, AccordionDetails, AccordionSummary, Card, CardContent, CardHeader, Container, FormControl, Grid, IconButton, InputLabel, ListItemText, MenuItem, Select, Table, TableBody, TableCell, TableRow, Tooltip, Typography } from '@mui/material'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import MyBreadcrumbs from '../../../components/MyBreadcrumbs'
import MyTable from '../../../components/MyTable'
import { AuthStore } from '../../../store/UserStore'
import { base_url } from '../../../utils/GlobalVariables'
import { CustomDescrypt } from '../../../utils/MyEncryption'
import Swal from 'sweetalert2'
import { ArrowBack, ExpandMore } from '@mui/icons-material'

const breadcrumbItem = { '/verif': 'Home', '/verif/selesai': 'Selesai' };

const thisMonth = new Date().getMonth() + 1;

const Selesai = () => {
    const logOut = AuthStore((state) => state.logOut)
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const [tableData, setTableData] = useState([]);
    const [bulan, setBulan] = useState(thisMonth);
    const [review, setReview] = useState(null);
    const [tableLoading, setTableLoading] = useState(false);
    const [kontrak, setKontrak] = useState({})

    useEffect(() => {
        if (review !== null) {
            if (review.kontrak !== "") {
                console.log('req kontrak');
                axios.get(
                    base_url + '/verif/kontrak/' + review.kontrak,
                    {
                        headers: {
                            'Authorization': `Bearer ${decryptedUser.token}`
                        }
                    })
                    .then((response) => {
                        console.log(response);
                        const data = response.data;
                        console.log(data);
                        setKontrak(data)
                    })
                    .catch((error) => {
                        if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                            logOut();
                        }
                    })
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [review])

    const columns = [
        {
            field: 'updated_at',
            headerName: 'Tanggal Update',
            filterable: false,
            hide: true
        },
        {
            field: 'created_at',
            headerName: 'Tanggal Input',
            filterable: false,
            hide: true
        },
        {
            field: 'no_spm',
            headerName: 'Nomor SPM',
            minWidth: 280,
        },
        { field: 'tgl_spm', headerName: 'Tanggal SPM' },
        {
            field: 'jenis',
            headerName: 'Jenis',
            width: 80,
            renderCell: (params) => {
                return params.row.jenis + " " + params.row.jenis_ls
            }
        },
        { field: 'keperluan', headerName: 'Keperluan', width: 430 },
        {
            field: 'anggaran',
            headerName: 'Anggaran',
            width: 150,
            renderCell: (params) => {
                return new Intl.NumberFormat("id-ID", {
                    style: "currency",
                    currency: "IDR",
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0,
                }).format(params.row.anggaran);
            }
        },
        { field: 'no_spp', headerName: 'Nomor SPP', width: 100, hide: true },
        {
            field: 'nm_opd',
            headerName: 'OPD',
            minWidth: 200,
            // type: "boolean"
        },
        {
            field: 'id_opd',
            headerName: 'ID OPD',
            hide: true
        }
    ];

    const requestData = (params) => {
        const frm = {
            bulan: params
        };
        setTableLoading(true)
        axios.post(
            base_url + '/verif/pencairan/selesai',
            frm,
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`,
                    'content-type': 'multipart/form-data'
                }
            })
            .then((response) => {
                const data = response.data;
                setTableData(data.pencairan)
                setTableLoading(false)
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.status + ' ' + error.response.statusText
                    })
                }
                setTableLoading(false)
            })
    }

    useEffect(() => {
        requestData(bulan);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bulan]);

    const handleBulan = (e) => {
        setBulan(e.target.value)
    }

    const handleTableRowClick = (params) => {
        setReview(params.row)
    }

    const rP = (e) => {
        const cur = new Intl.NumberFormat("id-ID", {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0
        }).format(e);
        return cur;
    }

    return (
        <>
            {/* <CssBaseline /> */}
            <MyBreadcrumbs breadcrumbItem={breadcrumbItem} title="Selesai" />
            <Container sx={{ my: 3 }} maxWidth="xxl">
                {
                    review === null ?
                        <Card>
                            <CardHeader
                                title={
                                    <Typography variant='h5'>Selesai</Typography>
                                }
                                // avatar={
                                //     <Tooltip title="Kembali">
                                //         <IconButton variant="outlined" onClick={() => {
                                //             setReview(null)
                                //         }} color="error"><ArrowBackIcon /></IconButton>
                                //     </Tooltip>
                                // }
                            />

                            <CardContent>
                                <Grid container spacing={2} direction="row" justifyContent="center">
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-standard-label">Pilih Bulan</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-standard-label"
                                                id="demo-simple-select-standard"
                                                value={bulan}
                                                label="Age"
                                                onChange={handleBulan}
                                                variant="standard"
                                            >
                                                <MenuItem selected={bulan === 1 ? true : false} value={1}>Januari {decryptedUser.tahun_anggaran}</MenuItem>
                                                <MenuItem selected={bulan === 2 ? true : false} value={2}>Februari {decryptedUser.tahun_anggaran}</MenuItem>
                                                <MenuItem selected={bulan === 3 ? true : false} value={3}>Maret {decryptedUser.tahun_anggaran}</MenuItem>
                                                <MenuItem selected={bulan === 4 ? true : false} value={4}>April {decryptedUser.tahun_anggaran}</MenuItem>
                                                <MenuItem selected={bulan === 5 ? true : false} value={5}>Mei {decryptedUser.tahun_anggaran}</MenuItem>
                                                <MenuItem selected={bulan === 6 ? true : false} value={6}>Juni {decryptedUser.tahun_anggaran}</MenuItem>
                                                <MenuItem selected={bulan === 7 ? true : false} value={7}>July {decryptedUser.tahun_anggaran}</MenuItem>
                                                <MenuItem selected={bulan === 8 ? true : false} value={8}>Agustus {decryptedUser.tahun_anggaran}</MenuItem>
                                                <MenuItem selected={bulan === 9 ? true : false} value={9}>September {decryptedUser.tahun_anggaran}</MenuItem>
                                                <MenuItem selected={bulan === 10 ? true : false} value={10}>Oktober {decryptedUser.tahun_anggaran}</MenuItem>
                                                <MenuItem selected={bulan === 11 ? true : false} value={11}>November {decryptedUser.tahun_anggaran}</MenuItem>
                                                <MenuItem selected={bulan === 12 ? true : false} value={12}>Desember {decryptedUser.tahun_anggaran}</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <MyTable
                                            rows={tableData}
                                            columns={columns}
                                            row_id={(row) => row.no_spm}
                                            onRowClick={handleTableRowClick}
                                            isLoading={tableLoading}
                                            cursorPointer={true}
                                        />
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                        :
                        <Card>
                            <CardHeader
                                title={
                                    <Typography variant='h5'>Detail</Typography>
                                }
                                avatar={
                                    <Tooltip title="Kembali">
                                        <IconButton variant="outlined" onClick={() => {
                                            setReview(null)
                                        }} color="error"><ArrowBack /></IconButton>
                                    </Tooltip>
                                }
                            />
                            <CardContent>
                                <Grid container spacing={2} sx={{ py: 4 }}>
                                    <Table>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell>
                                                    <ListItemText primary="No. SPM" secondary={review.no_spm} />
                                                </TableCell>
                                                <TableCell>
                                                    <ListItemText primary="No. SPP" secondary={review.no_spp} />
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>
                                                    <ListItemText primary="Tanggal SPM" secondary={review.tgl_spm} />
                                                </TableCell>
                                                <TableCell>
                                                    <ListItemText primary="Jenis Pencairan" secondary={review.jenis + " " + review.jenis_ls} />
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>
                                                    <ListItemText primary="Keperluan" secondary={review.keperluan} />
                                                </TableCell>
                                                <TableCell>
                                                    <ListItemText primary="Anggaran" secondary={"Rp " + rP(review.anggaran)} />
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </Grid>
                                <Grid container spacing={2} py={2} justifyContent="center">
                                    <Grid item xs={12} sx={{ textAlign: "center" }}>
                                        <Accordion>
                                            <AccordionSummary
                                                expandIcon={<ExpandMore />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >
                                                <Typography>Dokumen SPM dll</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <iframe width='100%' height={700} title="Pdf" src={base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + review.id_opd + '/' + review.jenis + '/spm/' + review.file} />
                                            </AccordionDetails>
                                        </Accordion>
                                    </Grid>
                                </Grid>
                                {
                                    review.progres > 2 &&
                                    <Grid container spacing={2} py={2} justifyContent="center">
                                        <Grid item xs={12} sx={{ textAlign: "center" }}>
                                            <Accordion>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMore />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <Typography>Surat Pengantar</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <iframe width='100%' height={700} title="Pdf" src={base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + review.id_opd + '/pengantar_sp2d/' + review.file} />
                                                </AccordionDetails>
                                            </Accordion>
                                        </Grid>
                                    </Grid>
                                }
                                {
                                    review.progres > 3 &&
                                    <Grid container spacing={2} py={2} justifyContent="center">
                                        <Grid item xs={12} sx={{ textAlign: "center" }}>
                                            <Accordion>
                                                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore />}>
                                                    <Typography>Surat Perjanjian</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <iframe width='100%' height={700} title="Pdf" src={base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + review.id_opd + '/' + review.jenis + '/surat_perjanjian/' + review.file} />
                                                </AccordionDetails>
                                            </Accordion>
                                        </Grid>
                                    </Grid>
                                }
                                {
                                    review.jenis === "LS" && review.jenis_ls === "Modal" ?
                                        <>
                                            <Grid container spacing={2} py={2} justifyContent="center">
                                                <Grid item xs={12} sx={{ textAlign: "center" }}>
                                                    <Accordion>
                                                        <AccordionSummary
                                                            expandIcon={<ExpandMore />}
                                                            aria-controls="panel1a-content"
                                                            id="panel1a-header"
                                                        >
                                                            <Typography>Dokumentasi</Typography>
                                                        </AccordionSummary>
                                                        <AccordionDetails>
                                                            <iframe width='100%' height={700} title="Pdf" src={base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + review.id_opd + '/' + review.jenis + '/dokumentasi/' + review.file} />
                                                        </AccordionDetails>
                                                    </Accordion>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={2} py={2} justifyContent="center">
                                                <Grid item xs={12} sx={{ textAlign: "center" }}>
                                                    <Accordion>
                                                        <AccordionSummary
                                                            expandIcon={<ExpandMore />}
                                                            aria-controls="panel1a-content"
                                                            id="panel1a-header"
                                                        >
                                                            <Typography>Berita Acara</Typography>
                                                        </AccordionSummary>
                                                        <AccordionDetails>
                                                            <iframe width='100%' height={700} title="Pdf" src={base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + review.id_opd + '/' + review.jenis + '/berita_acara/' + review.file} />
                                                        </AccordionDetails>
                                                    </Accordion>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={2} py={2} justifyContent="center">
                                                <Grid item xs={12} sx={{ textAlign: "center" }}>
                                                    <Accordion>
                                                        <AccordionSummary
                                                            expandIcon={<ExpandMore />}
                                                            aria-controls="panel1a-content"
                                                            id="panel1a-header"
                                                        >
                                                            <Typography>Progres</Typography>
                                                        </AccordionSummary>
                                                        <AccordionDetails>
                                                            <iframe width='100%' height={700} title="Pdf" src={base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + review.id_opd + '/' + review.jenis + '/progres/' + review.file} />
                                                        </AccordionDetails>
                                                    </Accordion>
                                                </Grid>
                                            </Grid>
                                        </>
                                        : ""

                                }
                                {
                                    review.jenis === "LS" && review.jenis_ls === "Gaji" ?
                                        <Grid container spacing={2} py={2} justifyContent="center">
                                            <Grid item xs={12} sx={{ textAlign: "center" }}>
                                                <Accordion>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMore />}
                                                        aria-controls="panel1a-content"
                                                        id="panel1a-header"
                                                    >
                                                        <Typography>Daftar Gaji</Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <iframe width='100%' height={700} title="Pdf" src={base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + review.id_opd + '/' + review.jenis + '/daftar_gaji/' + review.file} />
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid>
                                        </Grid>
                                        : ""
                                }
                                {
                                    review.kontrak === "" ?
                                        "" :
                                        (
                                            <Grid container spacing={2} py={2} justifyContent="center">
                                                <Grid item xs={12} sx={{ textAlign: "center" }}>
                                                    <Accordion>
                                                        <AccordionSummary
                                                            expandIcon={<ExpandMore />}
                                                            aria-controls="panel1a-content"
                                                            id="panel1a-header"
                                                        >
                                                            <Typography>Kontrak</Typography>
                                                        </AccordionSummary>
                                                        <AccordionDetails>
                                                            <iframe width='100%' height={700} title="Pdf" src={base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + review.id_opd + '/kontrak/' + kontrak.file} />
                                                        </AccordionDetails>
                                                    </Accordion>
                                                </Grid>
                                            </Grid>
                                        )
                                }
                                {
                                    review.jenis === "GU" ?
                                        (
                                            <Grid container spacing={2} py={2} justifyContent="center">
                                                <Grid item xs={12} sx={{ textAlign: "center" }}>
                                                    <Accordion>
                                                        <AccordionSummary
                                                            expandIcon={<ExpandMore />}
                                                            aria-controls="panel1a-content"
                                                            id="panel1a-header"
                                                        >
                                                            <Typography>SPJ Fungsional</Typography>
                                                        </AccordionSummary>
                                                        <AccordionDetails>
                                                            <iframe width='100%' height={700} title="Pdf" src={base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + review.id_opd + '/' + review.jenis + '/spj_fungsional/' + review.file} />
                                                        </AccordionDetails>
                                                    </Accordion>
                                                </Grid>
                                            </Grid>
                                        )
                                        : ""
                                }
                                <Grid container spacing={2} py={2} justifyContent="center">
                                    <Grid item xs={12} sx={{ textAlign: "center" }}>
                                        <Accordion>
                                            <AccordionSummary
                                                expandIcon={<ExpandMore />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >
                                                <Typography>SP2D</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <iframe width='100%' height={700} title="Pdf" src={base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + review.id_opd + '/' + review.jenis + '/sp2d/' + review.file} />
                                            </AccordionDetails>
                                        </Accordion>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                }
            </Container>

        </>
    )
}

export default Selesai